<template>
	<div class="msg_box">
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">积分详情</span>
			</div>
		</div>
		<div class="details_box clearfloat">
			<div class="flo_lf details_left">
				<div class="left_top">
					物流信息
				</div>
				<div class="left_zpz">
					<div class="mos">收货地址</div>：
					<div class="zpz_content">
						{{integral.ad_name}}
						{{integral.province_name}}
						{{integral.city_name}}
						{{integral.area_name}}
						{{integral.ad_address}}
						</div>
				</div>
				<div class="left_zpz">
					<div class=" mos">订单编号</div>：
					<div class="zpz_content">{{integral.out_trade_no}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos w3">联系人</div>：
					<div class="zpz_content">{{integral.ad_name}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos w2">单位</div>：
					<div class="zpz_content">{{integral.ad_unit}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos">联系电话</div>：
					<div class="zpz_content">{{integral.ad_phone}}</div>
				</div>
			</div>
			<div class="flo_right details_right">
				<div class="shehe">
					订单状态：
					<div class="lanse">{{integral.status | integralS}}</div>
				</div>
			</div>
			<!-- <div  class="flo_right details_right">
				<div class="left_top">
					订单状态：
				</div>
				<div class="czosa">
					交易成功
				</div>
				<div class="left_top">
					发货状态：部分发货
				</div>
				<div class="wei_zi">
					<div class="">n-Octyl-β-D-thioglucoside：已发货</div>
					<div class="">n-Octyl-β-D-thioglucoside：已发货</div>
				</div>
			</div> -->
		</div>
		
		<div>
			<p class="font20">卖家信息</p>
			<div class="zxcc">
				<span @click="xin.goUrl('/aboutUs/contactUs')" class="lan">联系我们</span>
				<span class="">邮箱：info@dojindo.cn</span>
				<span>
					微信公众号:<span class="lan" @click="isEwm=true">【同仁化学DOJINDO】</span>
				</span>
			</div>
		</div>
		<div class="tech_title">订单信息</div>
		<div class="order_to">
			<span>商品名称</span>
			<span>状态</span>
			<span>积分</span>
			<span>数量</span>
		</div>
		<div class="chopping_box">
			<div class="chopping_zi">
				<div class="chopping_li chopping_goods clearfloat">
					<img class="flo_lf" :src="integral.goods_images" />
					<div class="flo_lf asdmoi">
						<span>{{integral.goods_name}}</span>
						<span class="lan">积分兑换</span>
					</div>
				</div>
				<div class="chopping_li">
					{{integral.status | integralS}}
				</div>
				<div class="chopping_li">
					{{integral.total_integral}}
				</div>
				<div class="chopping_li">
					{{integral.number}}
				</div>
			</div>
		</div>
		<div class="clearfloat" v-if="integral.status==1">
			<div class="laing_btn" @click="Postintegralcancel">取消兑换</div>
		</div>
		<el-dialog class="erweima" title="扫码关注公众号" center :visible.sync="isEwm" width="400px">
			<img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/qrcode_for_gh_1bf2f15c3a63_430.jpg"/>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				isEwm:false,
				integral:{},//积分订单
			}
		},
		watch:{
			$route(to,fo){
				this.Postordersinfo(to.params.id);
			}
		},
		created() {
			this.Postordersinfo(this.$route.params.id);
		},
		methods:{
			async Postintegralcancel(){//取消订单
				this.$confirm('您确定要取消订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					let {code} = await this.api.Postintegralcancel({orders_id:this.integral.id});
					if(code==200){
						this.$message.success('订单取消成功!');
						this.xin.goUrl('/personalCenter/miOrder')
					}
				});
			},
			async Postordersinfo(orders_id){
				if(!orders_id)return;
				let {code,data} = await this.api.Postordersinfo({orders_id});
				this.integral = data;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.laing_btn{
		margin-top: 50px;
		float: right;
	}
	.font20{
		font-size: 20px;
		color: #333;
	}
	.lanse{
		font-size: 36px;
		color: #005599;
		line-height: 48px;
	}
	.zxcc{
		& > span{
			margin-right: 166px;
		}
	}
	.details_box{
		border: 1px solid #D9D9D9;
		// height: 250px;
		
		.details_right{
			box-sizing: border-box;
			width: 50%;
			height: 100%;
			.czosa{
				height: 90px;
				text-align: center;
				line-height: 90px;
				font-size: 36px;
				color: #005599;
			}
			.wei_zi{
				border-left: 1px solid #D9D9D9;
				padding:  30px 80px;
				div{
					font-size: 16px;
					font-weight: 500;
					color: #333333;
					line-height: 30px;
				}
			}
			.shehe{
				margin: 62px 110px;
			}
		}
		.left_top{
			padding-left: 40px;
			line-height: 40px;
			height: 40px;
			background-color: var(--themeColor);
			color: #fff;
		}
		.details_left{
			box-sizing: border-box;
			border-right: 1px solid #D9D9D9;
			width: 50%;
			padding-bottom: 20px;
			// padding: 20px 0 20px 40px;
			.left_zpz{
				padding-left: 40px;
				margin:  5px 0;
				color: #333333;
				display: flex;
				// justify-content: space-between;
				.w2{
					letter-spacing: 1.8em;
					    margin-right: 0;
				}
				.mos{
					
					width: 90px;
					margin-right: -1.4em;
					// letter-spacing:3px;
				}
				.zpz_content{
					font-size: 16px;
					color:#666666;
					line-height: 24px;
				}
			}
			
			
		}
		
	}
	.order_to {
		margin-top: 30px;
		color: #fff;
		height: 40px;
		background: #005599;
		display: flex;
		align-items: center;
	
		span:nth-child(1) {
			flex: 2;
			text-align: center;
		}
	
		span:not(:nth-child(1)) {
			flex: 1;
			text-align: center;
		}
	}
	.chopping_box {
		color: #333;
		.chopping_zi {
			display: flex;
			align-items: center;
			padding: 30px 0;
			height: 100px;
			border-bottom: 1px solid #D9D9D9;
	
			.chopping_li {}
	
			&>div {
				flex: 1;
				text-align: center;
			}
	
			.chopping_goods {
				flex: 2;
				margin-left: 20px;
				.asdmoi {
					height: 100px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;
					margin-left: 20px;
				}
	
				img {
					width: 100px;
					height: 100px;
				}
			}
		}
	}
</style>
